module.exports = __webpack_public_path__ + "static/AW_student_2-245ee903fd6361a374fba589e953df13.jpg";